'use client';

import { type FC, useState } from 'react';
import Image from 'next/legacy/image';

import styles from './Multi.component.module.scss';
import Link from 'next/link';
import type { MultiComponentStoryblok } from 'Entities/Storyblok';

const MultiComponent: FC<MultiComponentStoryblok> = ({ title, items = [], inline }) => {
  //console.log('MultiComponent', { title, items });

  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className={`${styles.component} container`} data-is-spaced data-is-inline={inline}>
      <div className={styles.title} hidden={!title}>
        {title}
      </div>
      <div className={styles.layout}>
        {inline && <div className={styles.padder} aria-hidden="true" />}
        <div className={styles.wrapper}>
          <div className={styles.nav}>
            {items.map((item, index) => (
              <button
                type="button"
                className={styles.navItem}
                key={item._uid}
                data-is-active={index === currentIndex}
                aria-pressed={index === currentIndex}
                onClick={() => setCurrentIndex(index)}
              >
                {item.title}
              </button>
            ))}
          </div>
          <div className={styles.content}>
            {items.map((item, index) => (
              <div className={styles.images} key={item._uid} data-is-active={index === currentIndex}>
                {item.images?.map((image) => (
                  <div className={styles.image} key={image.filename}>
                    <Image
                      src={`${image?.filename}/m/2000x1000`}
                      alt={image.alt ?? ''}
                      title={image.title}
                      layout="fill"
                      unoptimized
                    />
                  </div>
                ))}

                {item.link && (item.link?.cached_url || item.link?.url) && (
                  <Link
                    href={item.link?.cached_url ? `/${item.link.cached_url}` : `/${item.link?.url}`}
                    className={styles.link}
                    prefetch={false}
                  >
                    {item.title} <i className="fal fa-chevron-right" />
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export { MultiComponent };
